import React from "react";
import "./CardContains.css";
export default function CardContains({ InstitutionName, DegreeDetails, Year }) {
  return (
    <div className="card-contain">
      <span className="highlighted-card-text">
        <i
          class="fa-solid fa-circle-dot  fa-sm"
          style={{ color: "var(--dark-orange)" }}
        ></i>
        &nbsp;&nbsp;{InstitutionName}
        <span className="card-contain-tag">{Year}</span>
      </span>
      <br></br>
      <br></br>
      <p>
        {DegreeDetails}
        <br></br>
      </p>
    </div>
  );
}
